import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import SelectContainer from 'src/modules/commons/inputs/select/Select.container';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

export interface AdditionalComponentProps {
  formData: PhysicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  maritalStatusOptions: { name: string, value: string }[];
  maritalTypeOptions: { name: string, value: string }[];
  maritalEconomicStatus: { name: string, value: string }[];
  maritalProfession: { name: string, value: string }[];
}

class AdditionalDataFormComponent extends React.PureComponent<AdditionalComponentProps> {

  public render() {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question47"
        >
          <div className="icon-title">
            <img
              alt="More"
              className="icon"
              src="/img/add-user.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Completa tus datos
              </strong>
              <span className="d-arrow-up"/>
            </h4>
            <div className="gap-20"/>
          </div>
        </div>
        <div
          id="question47"
          className="collapse"
        >
          <div className="row">

              <SelectContainer
                  label="Estado civil"
                  value={this.props.formData.maritalStatus || ''}
                  handleChange={this.props.handleChange('maritalStatus')}
                  addEmptyOption={false}
                  itemSet={this.props.maritalStatusOptions}
                  required={true}
              />

            {this.props.formData.maritalStatus === 'Casado/a' ?
              <section>
                  <SelectContainer
                      label="Estado económico matrimonial"
                      value={this.props.formData.maritalEconomicStatus || ''}
                      handleChange={this.props.handleChange('maritalEconomicStatus')}
                      addEmptyOption={false}
                      itemSet={this.props.maritalEconomicStatus}
                      required={true}
                  />
                  {this.props.formData.maritalEconomicStatus === 'Régimen de gananciales' ?
                      <SelectContainer
                          label="Tipo de régimen de gananciales"
                          value={this.props.formData.maritalPropertyRegime || ''}
                          handleChange={this.props.handleChange('maritalPropertyRegime')}
                          addEmptyOption={false}
                          itemSet={this.props.maritalTypeOptions}
                          required={true}
                      /> :
                      null
                  }
              </section> :
              null
          }
          </div>
          <div className="row">
              <SelectContainer
                  label="Profesión"
                  value={this.props.formData.occupationType || ''}
                  handleChange={this.props.handleChange('occupationType')}
                  addEmptyOption={false}
                  itemSet={this.props.maritalProfession}
                  required={true}
              />
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="¿Cúal es su profesión?"
                  type="text"
                  value={this.props.formData.occupation || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('occupation')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Nombre de la compañía..."
                  type="text"
                  value={this.props.formData.company || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('company')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AdditionalDataFormComponent;



// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/AdditionalDataForm.component.tsx